// What the home page keeps as you left it for the session (Oct 2026): the
// library list you opened and whether it showed all its tunes, so Back from a
// tune lands on the link you followed rather than a collapsed card. Module
// memory, not the store: a reload starts the page afresh.

/** A library list: what was pressed on which card, and the tunes behind it. */
export interface LibrarySelection {
  card: string;
  /** What was pressed: a bar's label or a key's name. */
  label: string;
  heading: string;
  tunes: number[];
}

export const homeView: { open: LibrarySelection | null; all: boolean } = {
  open: null,
  all: false,
};

export function resetHomeView(): void {
  homeView.open = null;
  homeView.all = false;
}
